import type { JSX, KeyboardEvent } from 'react';
import { useI18n } from '../i18n/context.js';
import { STORY_STYLE_SUGGESTIONS } from './story-styles.js';

export function StoryStyleField({
  label,
  value,
  disabled = false,
  onChange,
  onCommit,
}: {
  readonly label: string;
  /** What the field shows: already passed through `styleDisplayName`. */
  readonly value: string;
  readonly disabled?: boolean;
  onChange(value: string): void;
  onCommit(value: string): void;
}): JSX.Element {
  const { t } = useI18n();
  const commitOnEnter = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    event.currentTarget.blur();
  };

  return (
    <div className="grid gap-2">
      <label className="grid gap-1.5 text-sm font-medium">
        {label}
        <input
          className="kitup-input"
          value={value}
          maxLength={200}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
          onBlur={() => onCommit(value)}
          onKeyDown={commitOnEnter}
        />
      </label>
      <div className="flex flex-wrap gap-2" aria-label={t.builder.styleSuggestionsLabel}>
        {STORY_STYLE_SUGGESTIONS.map((suggestion) => {
          const shown = t.builder.styleSuggestions[suggestion.label];
          return (
            <button
              key={suggestion.value}
              type="button"
              aria-pressed={value === shown}
              className="kitup-quiet-button rounded-full border border-[var(--kitup-color-border)] px-3 py-1.5 text-sm aria-pressed:border-[var(--kitup-color-accent)] aria-pressed:text-[var(--kitup-color-accent)]"
              disabled={disabled}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => {
                onChange(shown);
                onCommit(shown);
              }}
            >
              {shown}
            </button>
          );
        })}
      </div>
    </div>
  );
}
